module.exports = __webpack_public_path__ + "1d6109d7a61df856e72681ffe141ba90.svg";